// extracted by mini-css-extract-plugin
export var copyableField = "_sb-4";
export var customerBadge = "_sb-0";
export var customerInfoTitle = "_sb-2";
export var details = "_sb-1";
export var dropdownContainer = "_sb-5";
export var dropdownImage = "_sb-6";
export var editAssigneeForm = "_sb-a";
export var editButton = "_sb-3";
export var email = "_sb-7";
export var hidden = "_sb-d";
export var input = "_sb-8";
export var saveButton = "_sb-b";
export var shopifyIcon = "_sb-c";
export var suggestionBadge = "_sb-e";
export var suggestionText = "_sb-f";
export var username = "_sb-9";